import styled from 'styled-components'

export const Container = styled.footer`
  position: relative;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const Text = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
`

export const Anchor = styled.a`
  color: ${props => props.theme.colors.color378ff7};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  text-decoration-line: underline;
`
